// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Game_container__d7qqG {
    padding-top: 70px;
    text-align: center;

    /* padding-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center; 
    margin: auto 0;
    height: 80vh; */
} 

.Game_scoreWrapper__LGee0 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
}

.Game_coin__5TtBB {
    width: 30px;
    height: 30px;
    /* display: block; */
}

.Game_score__n\\+U1s {
    font-size: 40px;
    margin-right: 10px;
    font-weight: bold;
    
}

.Game_i__ZTNiJ {
    width: 18px;
    background-color: white;
    border-radius: 50%;
}


.Game_energyWrapper__RX62m{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 60px;
    font-size: 18px;
}

.Game_battery__ok049 {
    width: auto;
    height: 10px;
    /* margin-right: 10px; */
}

.Game_wolf__MKoIf {
    width: 80%;
    max-width: 350px;
    -webkit-tap-highlight-color: transparent; /* Убираем подсветку */
    -webkit-user-select: none;
  touch-action: manipulation; /* Оптимизация для тач-устройств */
  user-select: none; /* Запрещаем выделение текста */

  outline: none;
  
}

.Game_wolf__MKoIf:active {
    transform: scale(0.99);
    outline: none;
    box-shadow: none;

  }


  .Game_wolf__MKoIf:focus {
    outline: none !important;
    box-shadow: none;
  }




  /* button {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    
  }
  
  */`, "",{"version":3,"sources":["webpack://./src/Components/Game/Game.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;;IAElB;;;;;;;mBAOe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,wCAAwC,EAAE,sBAAsB;IAChE,yBAAyB;EAC3B,0BAA0B,EAAE,kCAAkC;EAC9D,iBAAiB,EAAE,+BAA+B;;EAElD,aAAa;;AAEf;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;;EAElB;;;EAGA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;;;;EAKA;;;;;GAKC","sourcesContent":[".container {\n    padding-top: 70px;\n    text-align: center;\n\n    /* padding-top: 20px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center; \n    margin: auto 0;\n    height: 80vh; */\n} \n\n.scoreWrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.coin {\n    width: 30px;\n    height: 30px;\n    /* display: block; */\n}\n\n.score {\n    font-size: 40px;\n    margin-right: 10px;\n    font-weight: bold;\n    \n}\n\n.i {\n    width: 18px;\n    background-color: white;\n    border-radius: 50%;\n}\n\n\n.energyWrapper{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 60px;\n    font-size: 18px;\n}\n\n.battery {\n    width: auto;\n    height: 10px;\n    /* margin-right: 10px; */\n}\n\n.wolf {\n    width: 80%;\n    max-width: 350px;\n    -webkit-tap-highlight-color: transparent; /* Убираем подсветку */\n    -webkit-user-select: none;\n  touch-action: manipulation; /* Оптимизация для тач-устройств */\n  user-select: none; /* Запрещаем выделение текста */\n\n  outline: none;\n  \n}\n\n.wolf:active {\n    transform: scale(0.99);\n    outline: none;\n    box-shadow: none;\n\n  }\n\n\n  .wolf:focus {\n    outline: none !important;\n    box-shadow: none;\n  }\n\n\n\n\n  /* button {\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    \n  }\n  \n  */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Game_container__d7qqG`,
	"scoreWrapper": `Game_scoreWrapper__LGee0`,
	"coin": `Game_coin__5TtBB`,
	"score": `Game_score__n+U1s`,
	"i": `Game_i__ZTNiJ`,
	"energyWrapper": `Game_energyWrapper__RX62m`,
	"battery": `Game_battery__ok049`,
	"wolf": `Game_wolf__MKoIf`
};
export default ___CSS_LOADER_EXPORT___;
